import React from 'react'
import server from '../server'
import EmailInput from '../inputs/EmailInput'
import CpfInput from '../inputs/CpfInput'

const styles = {
    div:{
        textAlign:"center",
    },

    textField: {
        margin: "10px 0px",
        width: 150,
    },

    fullWidth:{
        width:"310px",
        margin: "10px 3px"
    },

    button: {
        margin: 12,
    },

    paper:{
        position: "absolute",
        padding:30,
        width:300,
        textAlign: "center",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)"
    }
}

class NewSecretaryForm extends React.Component{
    state ={}

    componentWillMount = () =>{
        this.setState({clinicId: JSON.parse(localStorage.getItem("clinic")).id})
    }

    validate = () =>{
        let failed = false;

        console.log("juglub")

        if(this.state.name == null){
            this.setState({name_error: true})
            failed = true;
        }
  
        if(this.state.cpf == null){
            this.setState({cpf_error: true})
            failed = true;
        }
  
        if(this.state.email == null || this.state.email.split("@")[0] == ""){
            this.setState({email_error: true})
            failed = true;
        }

        if(!failed){
            this.register()
        }
    }

    onUpdate = (event) => {
		this.setState({[event.target.id]:event.target.value});
    }
    
    register = () => {
        let data = this.state;
        data["cpf"] = data["cpf"].replace(/\./g, '').replace(/\-/,'')
        fetch(server.address + "/secretaries",{
            method:"POST",
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json'
            },
            body: JSON.stringify(data)
        })
        this.props.close();
    }

    render(){
        return(
            <div style={styles.paper}>
                <input onChange={this.onUpdate} value={this.state.name} style={styles.textField} error={this.state.name_error} id="name" placeholder="Nome Secretária" required/>
                <input onChange={this.onUpdate} value={this.state.cpf} style={styles.textField} error={this.state.cpf_error} id="cpf" placeholder="CPF Secretária" inputComponent={CpfInput} required/><br/>
                <EmailInput onChange={this.onUpdate} email={this.state.email} style={styles.textField} error={this.state.email_error} id="email" placeholder="Email Secretária" required/><br/>
                <button onClick={this.validate}>Cadastrar</button>
            </div>
        )
    }

}

export default NewSecretaryForm


// WEBPACK FOOTER //
// ./src/forms/NewSecretaryForm.js